<template>
	<div class="integral">
		<back-to></back-to>
		<section class="integral_top">
			<img class="integral_top-img"
				:src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/integral-01.png?v='+Math.random()" alt="">
			<div class="integral_top-con">
				<span class="integral_top-cont">
					<p>{{user.score}}</p>
					<font>积分</font>
				</span>
				<span class="integral_top-conb">
					<img class="integral_top-cont_img"
						:src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/integral-02.png?v='+Math.random()"
						alt="" @click="$router.push({ path: '/shop'})">
					<label for="" @click="$router.push({ path: '/exchange'})">
						<p>兑换记录</p>
						<img class="integral_top-contr"
							:src="'https://sweetour-pic.obs.myhwclouds.com/sweetmini/integral-03.png?v='+Math.random()"
							alt="">
					</label>
				</span>
			</div>
		</section>
		<section class="integral_center">
			<h2>积分明细</h2>
			<p>每日登陆小程序可得20积分</p>
		</section>
		<!-- 列表 -->
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false"
			class="orderList-list">
			<div class="orderList-item" v-for="(item,index) in list" :key="index">
				<span>
					<p class="list-i-i-h" v-if="item.type==1">登陆签到</p>
					<p class="list-i-i-h" v-if="item.type==2">分享产品</p>
					<p class="list-i-i-h" v-if="item.type==3">分享小程序</p>
					<p class="list-i-i-h" v-if="item.type==4">购买产品</p>
					<p class="list-i-i-h" v-if="item.type==5">参加活动</p>
					<p class="list-i-i-h" v-if="item.type==6">积分兑换{{item.msg}}</p>
					<p class="list-i-i-t">{{item.createTime}}</p>
				</span>
				<span class="list-i-i-s" v-if="item.score > 0">+{{item.score}}</span>
				<span class="list-i-i-f">{{item.score}}</span>
			</div>
		</van-list>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import BackTo from '@/components/BackTo.vue'
	export default {
		name: 'integral',
		components: {
			BackTo
		},
		data() {
			return {
				user: "",
				loading: false,
				finished: false,
				pageIndex: 1,
				list: []
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {
			this.getMes()
			this.getList()
		},
		methods: {
			getMes() {
				var jsonData = {
					"ptId": this.$organizationId,
					"webUserId": this.userInfo.userId,
					"userName": this.userInfo.wxNick,
					"phone": this.userInfo.phone,
					"wxOpenId": "",
					"wxFace": this.userInfo.wxFace
				}
				this.$post(
					this.$activity + '/Score/ScoreUserGetById', jsonData
				).then(res => {
					this.user = res
				})
			},
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.pageIndex = this.pageIndex + 1
					this.getList()
				}, 500);
			},
			getList() {
				let param = {
					"ptId": this.$organizationId,
					"userId": this.userInfo.userId,
					"pageIndex": this.pageIndex,
					"pageSize": 10
				}
				this.$post(
					this.$activity + '/Score/ScoreHistoryGetAll', param
				).then(res => {
					this.list = this.list.concat(res.items)
					if (res.items.length < 10) {
						this.finished = true;
					}
				})
			},
		}
	}
</script>

<style scoped>
	.integral_top {
		width: 100%;
		height: 360px;
		position: relative;
	}

	.integral_top-img,
	.integral_top-con {
		width: 100%;
		height: 360px;
	}

	.integral_top-con {
		position: absolute;
		top: 0;
		left: 0;
		padding: 40px;
		box-sizing: border-box;
	}

	.integral_top-cont {
		display: flex;
		align-items: baseline;
		font-size: 24px;
		color: #fff;
		margin-top: 120px;
	}

	.integral_top-cont p {
		font-size: 60px;
		font-weight: bold;
		margin-right: 14px;
	}

	.integral_top-conb {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		padding-top: 14px;
	}

	.integral_top-conb p {
		color: #894400;
		font-size: 24px;
		margin-right: 10px;
	}

	.integral_top-conb label {
		display: flex;
		align-items: center;
	}

	.integral_top-cont_img {
		width: 166px;
	}

	.integral_top-contr {
		width: 10px;
	}

	.orderList-list {
		width: 100%;
		padding: 40px;
		box-sizing: border-box;
	}

	.orderList-item {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-bottom: 40px;
	}

	.list-i-i-h {
		font-size: 28px;
		color: #333;
	}

	.list-i-i-s {
		font-size: 30px;
		font-weight: bold;
		color: #ff6d00;
		display: flex;
		align-items: center;
	}

	.list-i-i-f {
		font-size: 30px;
		font-weight: bold;
		color: #999;
		display: flex;
		align-items: center;

	}

	.list-i-i-t {
		font-size: 24px;
		color: #999;
		margin-top: 14px;
	}

	.integral_center {
		width: 100%;
		padding: 40px 40px 20px 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		position: relative;
		top: -15px;
		z-index: 3;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		background-color: #fff;
	}

	.integral_center h2 {
		font-size: 36px;
		color: #333;
		font-weight: normal;
	}

	.integral_center p {
		color: #ff6d00;
		font-size: 24px;
	}
</style>
